<div class="tools">
  <ng-container *ngIf="studies | async as studies; else loading">
    <ng-container *ngIf="studies.length > 0; else empty">
      <select (change)="onStudyChange($event)" [(ngModel)]="selectedStudySk">
        <option *ngFor="let s of studies" [value]="s.studySk">
          {{ s.protocolNumber }} - {{ s.clientName }}
        </option>
      </select>
    </ng-container>
  </ng-container>
</div>
<div class="content">
  <ai-summary
    [summaryTitle]="'Study Summary 1'"
    [summary]="studySummaryOne"
    (kpiClicked)="onKpiClicked($event)"
  ></ai-summary>
  <ai-summary
    [summaryTitle]="'Study Summary 2'"
    [summary]="studySummaryTwo"
    (kpiClicked)="onKpiClicked($event)"
  ></ai-summary>
  <ai-summary
    [summaryTitle]="'Study Summary 3'"
    [summary]="studySummaryThree"
    (kpiClicked)="onKpiClicked($event)"
  ></ai-summary>
</div>

<ng-template #loading>
  <p>Loading studies...</p>
</ng-template>
<ng-template #empty>
  <p>No studies available</p>
</ng-template>
